/* ==========================================================
   BioMetabolic v2 - homepage menu anchors (brief Oct 1, Task 2)
   - Menu links like /#shop-by-stage, /#stage-2, /#tab-energy scroll to the right
     homepage section, below the sticky header.
   - /#tab-xxx also opens that side-effect tab.
   - /#stage-1..3 on mobile also slides the stage carousel to that box.
   - Works when the page opens with the hash (coming from another page)
     and when the visitor is already on the homepage and clicks the menu.
   - Closes the mobile menu drawer and desktop dropdowns after a click.
   File: assets/bm-anchors.js (loaded from layout/theme.liquid)
   ========================================================== */
(function () {
  var EXTRA_GAP = 12; /* px between the sticky header and the section title */

  function headerOffset() {
    var h = document.querySelector('.section-header');
    if (!h) return EXTRA_GAP;
    var r = h.getBoundingClientRect();
    var pos = getComputedStyle(h).position;
    /* only subtract the header when it stays on screen (sticky) */
    if (pos === 'sticky' || pos === 'fixed' || h.classList.contains('shopify-section-header-sticky')) {
      return Math.max(0, r.height) + EXTRA_GAP;
    }
    return EXTRA_GAP;
  }

  function scrollToEl(el, smooth) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
  }

  /* old tab links that now open another tab (brief Oct 20: Nutrients moved into Energy) */
  var TAB_ALIASES = { 'nutrients': 'energy' };

  /* open a side-effect tab by its key, e.g. "energy", "hair-skin" */
  function openTab(key) {
    if (TAB_ALIASES[key]) key = TAB_ALIASES[key];
    var tab = document.querySelector('.bm-tabs [role="tab"][data-tab-key="' + key + '"]') ||
              document.querySelector('.bm-tabs [role="tab"][data-tab-handle="' + key + '"]');
    if (!tab) return null;
    if (tab.getAttribute('aria-selected') !== 'true') tab.click();
    return tab.closest('.bm-tabs');
  }

  /* slide a horizontal carousel (mobile) so the card is the first one visible */
  function slideTo(card) {
    var track = card && card.parentElement;
    if (!track || track.scrollWidth <= track.clientWidth) return;
    var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft - pad, behavior: 'smooth' });
  }

  function closeMenus() {
    /* mobile drawer (Dawn header-drawer) */
    var drawer = document.querySelector('header-drawer');
    var details = drawer && drawer.querySelector('details');
    if (details && details.hasAttribute('open') && typeof drawer.closeMenuDrawer === 'function') {
      var summary = details.querySelector('summary');
      drawer.closeMenuDrawer(new Event('click'), summary);
      /* Dawn only resets this for keyboard closes; while it says "true" the grey
         overlay (drawn from the menu icon) stays on screen */
      drawer.querySelectorAll('summary[aria-expanded="true"]').forEach(function (s) {
        s.setAttribute('aria-expanded', 'false');
      });
      if (summary) summary.setAttribute('aria-expanded', 'false');
      var header = document.querySelector('.section-header');
      if (header) header.classList.remove('menu-open');
    }
    /* desktop dropdowns / mega menu */
    document.querySelectorAll('header-menu details[open], .header__inline-menu details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  /* returns true when the hash was handled */
  function go(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    var id = decodeURIComponent(hash.slice(1));

    if (id.indexOf('tab-') === 0) {
      var section = openTab(id.slice(4));
      if (!section) return false;
      scrollToEl(section, smooth);
      return true;
    }

    var el = document.getElementById(id);
    if (!el) return false;
    if (/^stage-\d+$/.test(id)) {
      var track = el.parentElement;
      var isSlider = track && track.scrollWidth > track.clientWidth;
      slideTo(el);
      /* on mobile scroll to the slider row, on desktop to the box */
      scrollToEl(isSlider ? track : el, smooth);
      return true;
    }
    scrollToEl(el, smooth);
    return true;
  }

  function isHomeLink(a) {
    if (!a || !a.hash) return false;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (e) { return false; }
    return url.origin === window.location.origin &&
           url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
  }

  /* clicks on menu / page links while already on the homepage */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || !isHomeLink(a)) return;
    var id = decodeURIComponent(a.hash.slice(1));
    if (id.indexOf('tab-') !== 0 && !document.getElementById(id)) return;
    e.preventDefault();
    var fromDrawer = !!a.closest('header-drawer, .menu-drawer');
    closeMenus();
    if (history.pushState) history.pushState(null, '', a.hash);
    /* let the drawer close (it unlocks page scrolling) before scrolling */
    setTimeout(function () { go(a.hash, true); }, fromDrawer ? 350 : 0);
  });

  /* back / forward between hashes */
  window.addEventListener('hashchange', function () { go(window.location.hash, true); });

  /* page opened with a hash (e.g. from another page): correct the position
     after layout settles (fonts, images) */
  if (window.location.hash) {
    var h = window.location.hash;
    var run = function () { go(h, false); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    window.addEventListener('load', function () { setTimeout(run, 50); });
  }
})();
